var map = {
	"./platform": [
		8047,
		7745
	],
	"./platform.js": [
		8047,
		7745
	],
	"./system": [
		3753,
		8699
	],
	"./system.js": [
		3753,
		8699
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9285;
module.exports = webpackAsyncContext;